// Util de máscara decimal com digitação da direita para a esquerda
// Reutilizável para qualquer campo numérico com casas decimais

export const toThousandsBR = (s: string) => s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export const rawFromNumber = (n: number, decimals: number) => {
  const factor = Math.pow(10, Math.max(0, decimals));
  const val = Math.max(0, Math.round((n || 0) * factor));
  return String(val);
};

export const formatFromRaw = (raw: string, decimals: number): string => {
  const d = Math.max(0, decimals);
  const digits = (raw || '').replace(/\D/g, '') || '0';
  const frac = digits.padStart(d, '0').slice(-d);
  const intRaw = digits.length > d ? digits.slice(0, -d) : '0';
  const intFmt = toThousandsBR(intRaw.replace(/^0+/, '') || '0');
  return `${intFmt},${frac}`;
};

export const parseRawToNumber = (raw: string, decimals: number) => {
  const d = Math.max(0, decimals);
  const digits = (raw || '').replace(/\D/g, '') || '0';
  const factor = Math.pow(10, d);
  const val = (parseInt(digits, 10) || 0) / factor;
  return val;
};

// Converte texto digitado (com vírgula, ponto, espaços, moeda) em "raw" (apenas dígitos)
// Útil para inputs mobile que disparam onChange, não onKeyDown
export const rawFromTyped = (text: string, decimals: number) => {
  const d = Math.max(0, decimals);
  if (!text) return '0'.padStart(1, '0');
  // Remover tudo que não é dígito
  const digits = text.replace(/\D/g, '') || '0';
  // Garantir ao menos d dígitos para formatação consistente
  // (o raw em si pode ser curto; o formatador cuida do pad)
  const normalized = digits.replace(/^0+(?=\d)/, '') || '0';
  return normalized;
};

export const getNextRawOnKey = (key: string, currentRaw: string) => {
  if (/^\d$/.test(key)) {
    const nextRaw = (currentRaw + key).replace(/^0+(?=\d)/, '');
    return { handled: true, nextRaw };
  }
  if (key === 'Backspace') {
    const nextRaw = currentRaw.slice(0, -1);
    const normalized = (nextRaw.replace(/^0+(?=\d)/, '') || '0');
    return { handled: true, nextRaw: normalized };
  }
  if (key === 'Delete') {
    return { handled: true, nextRaw: '0' };
  }
  if (key === ',' || key === '.') {
    return { handled: true, nextRaw: currentRaw };
  }
  return { handled: false, nextRaw: currentRaw };
};